import { Link, useNavigate, useParams } from 'react-router-dom';
import { listByDate } from '../../db/entries';
import { getCategoryMap } from '../../db/categories';
import { emptyProjects, getProjectsDoc } from '../../db/projects';
import { useAsync } from '../hooks/useAsync';
import { useDataVersion } from '../../db/events';
import { EntryCard } from '../components/EntryCard';
import { DailyCard } from '../components/DailyCard';
import { TaskChecklist } from '../components/TaskChecklist';
import {
  addDays,
  dateKeyToDate,
  formatDateJa,
  toDateKey,
} from '../../lib/datetime';
import type { Category, ProjectsDoc } from '../../domain/types';

export function DayView({ dateKey }: { dateKey?: string } = {}) {
  const version = useDataVersion();
  const params = useParams();
  const date = dateKey ?? params.date ?? toDateKey(new Date());
  const navigate = useNavigate();
  const day = dateKeyToDate(date);

  const entries = useAsync(() => listByDate(date), [date, version], []);
  const categories = useAsync<Map<string, Category>>(getCategoryMap, [version], new Map());
  const projects = useAsync<ProjectsDoc>(getProjectsDoc, [version], emptyProjects());

  return (
    <div className="view">
      <header className="view-head">
        <button
          className="nav-btn"
          onClick={() => navigate(`/day/${toDateKey(addDays(day, -1))}`)}
          aria-label="前日"
        >
          ‹
        </button>
        <div className="view-title">
          <h1>{formatDateJa(day)}</h1>
          <input
            type="date"
            value={date}
            onChange={(e) => navigate(`/day/${e.target.value}`)}
            aria-label="日付を選択"
          />
        </div>
        <button
          className="nav-btn"
          onClick={() => navigate(`/day/${toDateKey(addDays(day, 1))}`)}
          aria-label="翌日"
        >
          ›
        </button>
        <button className="today-btn" onClick={() => navigate(`/day/${toDateKey(new Date())}`)}>
          今日
        </button>
        {/* 表示中の日付に対して作るので、日付の隣に置く */}
        <Link className="primary-btn head-new" to={`/new?date=${date}`}>
          ＋ 新規
        </Link>
      </header>

      <div className="view-body">
        <TaskChecklist kind="daily" period={date} />
        <DailyCard date={date} />
        {entries.length === 0 ? (
          <div className="empty">
            <p>この日の記録はありません</p>
            <Link className="primary-btn" to={`/new?date=${date}`}>
              ＋ 記録する
            </Link>
          </div>
        ) : (
          <div className="card-list">
            {entries.map((e) => (
              <EntryCard key={e.id} entry={e} categories={categories} projects={projects} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
